import React, { useState, useEffect } from 'react';
import { getTodos, updateTodo } from '../../api/todo';
import './TodoPage.css';
import EditButton from '../../Component/common/ActionButton/EditButton';
import DeleteButton from '../../Component/common/ActionButton/DeleteButton';
import WhatsAppButton from '../../Component/common/ActionButton/WhatsAppButton';

const TodoPage = () => {
  const [todos, setTodos] = useState([]);
  const [newTodoText, setNewTodoText] = useState('');
  const [newTargetDate, setNewTargetDate] = useState('');

  const loadTodos = async () => {
    try {
      const response = await getTodos();
      if (response && response.data) {
        setTodos(response.data);
      } else {
        setTodos([]);
      }
    } catch (error) {
      console.error('Failed to load todos:', error);
      setTodos([]);
    }
  };

  useEffect(() => {
    loadTodos();
  }, []);

  const addTodo = () => {
    if (!newTodoText || !newTargetDate) return;
    // This addTodo is local UI only, consider removing or updating to use backend add
    const newTodo = {
      id: Date.now(),
      text: newTodoText,
      status: 'pending',
      targetDate: newTargetDate,
    };
    const updatedTodos = [...todos, newTodo];
    setTodos(updatedTodos);
    setNewTodoText('');
    setNewTargetDate('');
  };

  const toggleStatus = async (id) => {
    const todo = todos.find(t => t.id === id || t.todo_id === id);
    if (!todo) return;

    const newStatus = todo.status === 'pending' ? 'completed' : 'pending';

    try {
      await updateTodo(id, { ...todo, status: newStatus });
      const updatedTodos = todos.map(t =>
        (t.id === id || t.todo_id === id) ? { ...t, status: newStatus } : t
      );
      setTodos(updatedTodos);
    } catch (error) {
      console.error('Failed to update todo status:', error);
    }
  };

  // Filter out todos completed more than 2 days ago
  const now = new Date();
  const twoDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);

  const isRecentOrPending = (todo) => {
    if (todo.status !== 'completed' && todo.status !== 'done') return true;
    const updatedAt = new Date(todo.updatedAt || todo.updated_at);
    return updatedAt >= twoDaysAgo;
  };

  const contactsTodos = todos.filter(todo => todo.source === 'contacts' && isRecentOrPending(todo));
  const otherTodos = todos.filter(todo => todo.source !== 'contacts' && isRecentOrPending(todo));

  return (
    <div className="todo-container">
      <h2>Todo List</h2>
      <div className="todo-inputs">
        <input
          type="text"
          placeholder="Enter todo"
          value={newTodoText}
          onChange={e => setNewTodoText(e.target.value)}
        />
        <input
          type="date"
          value={newTargetDate}
          onChange={e => setNewTargetDate(e.target.value)}
        />
        <button onClick={addTodo} className="btn add-btn">Add Task</button>
        <button onClick={loadTodos} className="btn refresh-btn">Refresh</button>
      </div>

      <div className="todo-tables-container">
        <div>
          <h3>Contacts Todos</h3>
          {contactsTodos.length === 0 && <p>No todos added from contacts yet.</p>}
          {contactsTodos.length > 0 && (
            <table className="todo-table">
              <thead>
            <tr>
              <th className="todo-table-checkbox"></th>
              <th>Todo</th>
              <th>Target Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {contactsTodos.map(todo => (
              <tr key={todo.id || todo.todo_id}>
                <td className="todo-table-checkbox">
                  <input
                    type="checkbox"
                    checked={todo.status === 'completed' || todo.status === 'done'}
                    onChange={() => toggleStatus(todo.id || todo.todo_id)}
                    id={`todo-${todo.id || todo.todo_id}`}
                  />
                </td>
                <td>
                  <label
                    htmlFor={`todo-${todo.id || todo.todo_id}`}
                    className={`todo-table-label ${todo.status === 'completed' || todo.status === 'done' ? 'completed' : ''}`}
                  >
                    {todo.name || todo.text} - {todo.number || ''} - {todo.productName || ''}
                  </label>
                </td>
                <td>{new Date(todo.targetDate || todo.target_date).toLocaleDateString()}</td>
                <td>{todo.status || 'pending'}</td>
                <td className="actions-cell">
                  <div className="action-buttons">
                    <EditButton onClick={() => console.log('Edit', todo.id)} title="Edit" />
                    <DeleteButton title="Delete" onClick={() => console.log('Delete', todo.id)} />
                    <WhatsAppButton title="Send WhatsApp message" phone={todo.number || ''} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
        </div>
        <div>
          <h3>Other Todos</h3>
          {otherTodos.length === 0 && <p>No other todos added yet.</p>}
          {otherTodos.length > 0 && (
            <table className="todo-table">
              <thead>
            <tr>
              <th className="todo-table-checkbox"></th>
              <th>Todo</th>
              <th>Target Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {otherTodos.map(todo => (
              <tr key={todo.id || todo.todo_id}>
                <td className="todo-table-checkbox">
                  <input
                    type="checkbox"
                    checked={todo.status === 'completed' || todo.status === 'done'}
                    onChange={() => toggleStatus(todo.id || todo.todo_id)}
                    id={`todo-${todo.id || todo.todo_id}`}
                  />
                </td>
                <td>
                  <label
                    htmlFor={`todo-${todo.id || todo.todo_id}`}
                    className={`todo-table-label ${todo.status === 'completed' || todo.status === 'done' ? 'completed' : ''}`}
                  >
                    {todo.name || todo.text} - {todo.number || ''} - {todo.productName || ''}
                  </label>
                </td>
                <td>{new Date(todo.targetDate || todo.target_date).toLocaleDateString()}</td>
                <td>{todo.status || 'pending'}</td>
                <td className="actions-cell">
                  <div className="action-buttons">
                    <EditButton onClick={() => console.log('Edit', todo.id)} title="Edit" />
                    <DeleteButton title="Delete" onClick={() => console.log('Delete', todo.id)} />
                    <WhatsAppButton title="Send WhatsApp message" phone={todo.number || ''} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
        </div>
      </div>
    </div>
  );
};

export default TodoPage;
